// common/services/player/deleteFamilyContact.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export type DeleteFamilyContactInput = {
  /** Player whose family the contact belongs to. */
  playerId: string
  /** The contact being removed. */
  contactId: string
}

export type DeleteFamilyContactResponse = {
  id?: string
  status?: 'deleted'
} & Record<string, unknown>

/**
 * DELETE /players/:playerId/family/:contactId — removes a family contact from
 * the player's family.
 */
export const deleteFamilyContact = async (
  input: DeleteFamilyContactInput
): Promise<DeleteFamilyContactResponse> => {
  const { data } = await req(
    ENDPOINTS.PLAYERS.DELETE_PLAYER_FAMILY_CONTACT(
      input.playerId,
      input.contactId
    ),
    { method: 'DELETE' }
  )
  return data as DeleteFamilyContactResponse
}
